import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaProperty } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import SidePanelCaseMaterials from "../../layout/SidePanel/layouts/SidePanelCaseMaterials";

export const CaseMaterialsSchema: ISchema = {
    displayName: "Collection",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelCaseMaterials data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.string,
            descriptor: true,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'quantity',
            displayName: 'Quantity',
            type: PropertyTypes.number,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.year,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'status',
            displayName: 'Status',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'currentLocation',
            displayName: 'Current Location',
            type: PropertyTypes.breadcrumb,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
    ],

    children:[ 
        {entityName: EntityNames.specimens, displayName: "Specimens", viewType: EntityViewTypes.list, enableFilters: true} as ISchemaChild,
    ]
}
